export default {
  name: "WorldspanToggle",
  props: {
    on: { type: Boolean, default: false },
    data: { type: Object },
  },
  render() {
    return this.$scopedSlots.default({
      on: this.currentState,
      setOn: this.setOn,
      setOff: this.setOff,
      toggle: this.toggle,
      slotProp: this.data,
    });
  },
  data() {
    return { currentState: this.on };
  },
  methods: {
    setOn() {
      this.currentState = true;
    },
    setOff() {
      this.currentState = false;
    },
    toggle() {
      this.currentState = !this.currentState;
    },
  },
  watch: {
    on(newValue) {
      this.currentState = newValue;
    },
    currentState(newValue) {
      this.$emit("toggled", newValue);
    },
  },
};
